import {
    Flex,
    Stack,
    Modal,
    ModalBody,
    ModalOverlay,
    ModalContent,
    Textarea,
    ModalHeader,
    ModalFooter,
    Button,
} from '@chakra-ui/react';
import ZaraButton from '../../components/custom-components/buttons/Button';

const AgentResponseModal = ({ isOpenPopover, onClose, setFixText, onHandleFix, fixText, isLoading = false }) => {
    return (
        <Modal
            blockScrollOnMount={false}
            isCentered
            isOpen={isOpenPopover}
            onClose={onClose}
            motionPreset='slideInBottom'
            size='xl'
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Fix Agent Response</ModalHeader>
                <ModalBody>
                    <Stack spacing='12px'>
                        <Textarea
                            value={fixText}
                            onChange={(e) => setFixText(e.target.value)}
                            placeholder="Describe the issue with the agent\'s response..."
                            _placeholder={{ fontSize: 'sm' }}
                            rows={5}
                            px='2'
                        />{' '}
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Flex w='full' justifyContent='space-between'>
                        <Button onClick={onClose} variant='outline' w='auto' fontSize='sm'>
                            Cancel
                        </Button>
                        <ZaraButton onClick={onHandleFix} w='auto' fontSize='sm' isLoading={isLoading}>
                            Submit
                        </ZaraButton>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default AgentResponseModal;
